<template>
  <div class="related-terms">
    <a-assistant-button
      class="related-terms__button"
      :button-id="$options.consts.ASSISTANT_BUTTON_ID.RELATED_TERMS"
    />
    <directory-promotion-banner :categories="directoryCategories" />
    <div class="related-terms__terms-container">
      <h2>Related Terms</h2>

      <ul class="related-terms__terms">
        <li v-for="term in relatedTerms" :key="term.Slug">
          <h3 class="normal">
            <a-link
              :to="generateTermRoute(term)"
              class="related-terms__term-link"
              >{{ term.Name }}</a-link
            >
          </h3>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import DirectoryPromotionBanner from './DirectoryPromotionBanner'
import AAssistantButton from 'shared/AAssistantButton'
import { propValidator, PROP_TYPES } from '@/utils/validators'
import mixins from '@/utils/mixins'
import { ASSISTANT_BUTTON_ID } from 'shared/AAssistantButton/enums'

export default {
  name: 'ARelatedTerms',
  mixins: [mixins.urlGenerators],
  components: { AAssistantButton, DirectoryPromotionBanner },
  props: {
    relatedTerms: propValidator([PROP_TYPES.ARRAY]),
    directoryCategories: propValidator([PROP_TYPES.ARRAY])
  },
  consts: {
    ASSISTANT_BUTTON_ID
  }
}
</script>

<style lang="scss" scoped>
$offset: 30px;
$offset-mobile: 20px;

.related-terms {
  width: 100%;
  max-width: 410px;
  padding: $offset;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);

  @include desktop-md {
    max-width: 100%;
    margin-bottom: 50px;
  }

  @include mobile {
    box-shadow: none;
    margin-bottom: 0;
    padding: 0;
  }

  .related-terms__button {
    width: 100%;
    height: 75px;
    margin-bottom: $offset;
    max-width: 350px;

    @include desktop-md {
      max-width: 300px;
      margin-left: auto;
      margin-right: auto;
    }

    @include mobile {
      height: 26px;
      margin-bottom: $offset-mobile;
    }
  }

  /*TODO - delete after checking merge request*/
  &__banner {
    width: 100%;
    height: 450px;
    margin-bottom: $offset;
    background-color: $c--gray-cloud;

    @include mobile {
      margin-bottom: $offset-mobile;
    }
  }

  &__terms {
    border-bottom: 1px solid transparent;

    :not(:last-child) {
      border-bottom: 1px solid $c--gray-cloud;
    }
  }

  &__term-link {
    display: inline-block;
    line-height: 44px;
    font-size: 22px;
    color: $c--main;
    padding: 10px 0;

    &:hover {
      color: $c--gray-main;
    }

    @include mobile {
      font-size: 16px;
      line-height: 32px;
    }
  }
}
</style>
